export const CASINO_THEMES = {
  pirate: {
    id: 'pirate',
    name: 'Pirate Fortune',
    description: 'Moonlit treasure ships, gold and emerald casino energy.',
    status: 'active',
  },
  cartoon: {
    id: 'cartoon',
    name: 'Cartoon Royale',
    description: 'A playful animated casino world.',
    status: 'coming-soon',
  },
};

export const DEFAULT_CASINO_THEME = 'pirate';

export function getCasinoTheme() {
  if (typeof window === 'undefined') return CASINO_THEMES[DEFAULT_CASINO_THEME];
  const saved = window.localStorage.getItem('vegas-casino-theme');
  return CASINO_THEMES[saved] || CASINO_THEMES[DEFAULT_CASINO_THEME];
}

export function applyCasinoTheme(themeId = DEFAULT_CASINO_THEME) {
  const theme = CASINO_THEMES[themeId]?.status === 'active'
    ? CASINO_THEMES[themeId]
    : CASINO_THEMES[DEFAULT_CASINO_THEME];
  if (typeof document !== 'undefined') document.documentElement.dataset.casinoTheme = theme.id;
  if (typeof window !== 'undefined') window.localStorage.setItem('vegas-casino-theme', theme.id);
  return theme;
}
